import { Pagination, Resource, Statement } from "@/helpers/Interfaces";
import Pager from "@/helpers/Pager";
import axios from "axios";
import { merge } from "lodash";

export default class CitiesService
{
    /**
     * @param pager Pager
     * @param filter FilterModel
     *
     * @returns Promise<Pagination<Resource<ListItemModel>>>
     */
    public static async getList(pager: Pager, filter: FilterModel): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/renters/cities', {
            params: merge({}, pager.data(), filter)
        })).data;
    }

    /**
    * @param publicId string
    *
    * @returns Promise<Resource<ListItemModel>>
    */
    public static async fetch(publicId: string): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`admin/renters/cities/${publicId}`)).data;
    }

    /**
     * @param model FormModel
     *
     * @returns Promise<Resource<FormModel>>
     */
    public static async create(model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.post<Resource<FormModel>>('admin/renters/cities', model)).data;
    }

    /**
     * @param publicId string
     * @param model FormModel
     *
     * @returns Promise<Statement>
     */
    public static async update(publicId: string, model: FormModel): Promise<Statement>
    {
        return (await axios.put<Statement>(`admin/renters/cities/${publicId}`, model)).data;
    }

    /**
    * @param publicId string
    *
    * @returns Promise<Statement>
    */
    public static async remove(publicId: string): Promise<Statement>
    {
        return (await axios.delete(`admin/renters/cities/${publicId}`)).data;
    }

    /**
     * @param search string
     * @param limit number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getCitiesAutocompleteList(search: string, limit: number = 10, showAllRecords: boolean = true): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>('admin/renters/cities/autocomplete', {
            params: {
                search: search,
                limit: limit,
                allRecordsVisible: showAllRecords
            }
        })).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<CityItemModel>
     */
    public static async fetchCityAutocompleteModel(publicId: string): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`admin/renters/cities/autocomplete/${publicId}`)).data;
    }
}

export interface ListItemModel
{
    id: number;
    publicId: string;
    city: string;
    regionId: number;
    region: string;
    switchDateUtc: Date
}

export interface FilterModel
{
    cityPublicId: string;
    regionPublicId: string;
    switchDate: Date;
}

export interface FormModel
{
    id: number;
    publicId: string;
    city: string;
    regionId: number;
    regionPublicId: string;
    switchDateUtc: Date
}
